import React from "react";
import { HelpIndicator } from "@jsq/ds/core";
import { buttonWrapperDiv } from "./style_vanilla.css";

type ButtonWrapperProps = {
  children: React.ReactNode;
  tooltip?: string;
  id?: string;
};

export const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  children,
  tooltip,
  id,
}: ButtonWrapperProps) => {
  return tooltip ? (
    <HelpIndicator content={tooltip} id={id}>
      <div className={buttonWrapperDiv}>{children}</div>
    </HelpIndicator>
  ) : (
    <>{children}</>
  );
};
